// Terms of Service / Privacy Policy / COPPA Notice pages (HOP-135).

import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Grain } from '@/components/hs/Grain'
import termsMd from './content/terms.md?raw'
import privacyMd from './content/privacy.md?raw'
import coppaMd from './content/coppa.md?raw'
import '@/styles/legal-page.css'

function LegalPageShell({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="hs-brand legal-page">
      <Grain />
      <div className="legal-page__inner">
        <Link to="/" className="legal-page__back">
          ← Back to Hopscotch
        </Link>

        <h1 className="legal-page__title">
          {title}
        </h1>

        <div className="legal-md">{children}</div>
      </div>
    </div>
  )
}

function LegalMarkdown({ source }: { source: string }) {
  return <ReactMarkdown remarkPlugins={[remarkGfm]}>{source}</ReactMarkdown>
}

export function TermsPage() {
  return (
    <LegalPageShell title="Terms of Service">
      <LegalMarkdown source={termsMd} />
    </LegalPageShell>
  )
}

export function PrivacyPolicyPage() {
  return (
    <LegalPageShell title="Privacy Policy">
      <LegalMarkdown source={privacyMd} />
    </LegalPageShell>
  )
}

export function CoppaNoticePage() {
  return (
    <LegalPageShell title="COPPA Notice & Parental Consent">
      <LegalMarkdown source={coppaMd} />
    </LegalPageShell>
  )
}
